(() => {
  const pending = new WeakMap();

  const timestamp = (value) => {
    if (typeof value === 'string' && /^\d+(\.\d+)?$/.test(value)) value = Number(value);
    if (typeof value === 'number' && Number.isFinite(value)) {
      return value < 100000000000 ? value * 1000 : value;
    }
    return typeof value === 'string' && value ? Date.parse(value) : NaN;
  };

  const validateRecord = (record, variantId, locationId) => {
    if (!record || String(record.id) !== String(variantId)) return false;
    const sourceTime = timestamp(record.source_updated_at);
    const now = Date.now();
    return String(record.location_id).split('/').pop() === locationId
      && Number.isSafeInteger(record.available)
      && Number.isSafeInteger(record.total_available)
      && Number.isSafeInteger(record.current_total_available)
      && record.total_available === record.current_total_available
      && Number.isFinite(sourceTime) && sourceTime > 0 && sourceTime <= now + 30000;
  };

  const readInventory = async (event) => {
    const component = event.detail?.component;
    const variantId = String(event.detail?.variantId || '');
    if (!component?.isConnected || !/^\d+$/.test(variantId)) return;
    pending.get(component)?.abort();
    const controller = new AbortController();
    pending.set(component, controller);
    const timer = setTimeout(() => controller.abort(), 8000);

    try {
      const url = new URL(component.dataset.productUrl, window.location.origin);
      if (url.origin !== window.location.origin || !url.pathname.includes('/products/')) {
        throw new Error('Invalid inventory source');
      }
      url.searchParams.set('section_id', 'me-agentur-inventory-data');
      url.searchParams.set('_me_stock', String(Date.now()));
      if (/^\d+$/.test(component.dataset.themeId || '')) {
        url.searchParams.set('preview_theme_id', component.dataset.themeId);
      }
      const response = await fetch(url, {
        credentials: 'same-origin',
        cache: 'no-store',
        signal: controller.signal,
        headers: { Accept: 'text/html' }
      });
      if (!response.ok) throw new Error('Inventory source unavailable');
      const markup = new DOMParser().parseFromString(await response.text(), 'text/html');
      const data = markup.querySelector('[data-me-agentur-stock-response]');
      const records = JSON.parse(data?.textContent || 'null');
      if (!Array.isArray(records)) throw new Error('Invalid inventory data');
      const record = records.find((item) => String(item.id) === variantId);
      const verified = validateRecord(record, variantId, component.dataset.locationId);
      if (pending.get(component) !== controller || !component.isConnected) return;
      component.applyInventory(variantId, verified ? record.available : 0, verified, Date.now());
      component.dataset.inventorySourceStatus = verified ? 'verified' : 'unverified';
    } catch {
      if (pending.get(component) === controller && component.isConnected) {
        component.applyInventory(variantId, 0, false);
        component.dataset.inventorySourceStatus = 'unavailable';
      }
    } finally {
      clearTimeout(timer);
      if (pending.get(component) === controller) pending.delete(component);
    }
  };

  document.addEventListener('me:agentur:inventory-request', readInventory);
  customElements.whenDefined('me-agentur-inventory').then(() => {
    document.querySelectorAll('me-agentur-inventory').forEach((component) => {
      if (!pending.has(component)) component.requestInventory();
    });
  });
})();
